export function getNameWithLastFourSymbolPhoneNumber(member) {
  if (!member) {
    return ''
  }
  return `${member.name} ${member.personalData.phone.substr(-4)}`
}
